/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanTaskResponseDto } from './PlanTaskResponseDto';
import {
    PlanTaskResponseDtoFromJSON,
    PlanTaskResponseDtoFromJSONTyped,
    PlanTaskResponseDtoToJSON,
    PlanTaskResponseDtoToJSONTyped,
} from './PlanTaskResponseDto';

/**
 * 
 * @export
 * @interface ListPlanTasksResponseDto
 */
export interface ListPlanTasksResponseDto {
    /**
     * 
     * @type {Array<PlanTaskResponseDto>}
     * @memberof ListPlanTasksResponseDto
     */
    data: Array<PlanTaskResponseDto>;
}

/**
 * Check if a given object implements the ListPlanTasksResponseDto interface.
 */
export function instanceOfListPlanTasksResponseDto(value: object): value is ListPlanTasksResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListPlanTasksResponseDtoFromJSON(json: any): ListPlanTasksResponseDto {
    return ListPlanTasksResponseDtoFromJSONTyped(json, false);
}

export function ListPlanTasksResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPlanTasksResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PlanTaskResponseDtoFromJSON)),
    };
}

export function ListPlanTasksResponseDtoToJSON(json: any): ListPlanTasksResponseDto {
    return ListPlanTasksResponseDtoToJSONTyped(json, false);
}

export function ListPlanTasksResponseDtoToJSONTyped(value?: ListPlanTasksResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PlanTaskResponseDtoToJSON)),
    };
}

